import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { GlobalNotificationProto } from '../proto/generated/global-notification'
import { GlobalNotificationsState } from '../reducer/globalNotification.reducer'

const state = (state: RootState) => state.globalNotificationStore as GlobalNotificationsState

export const selectGlobalNotificationTab = createDraftSafeSelector(state, (store) => store.globalNotificationTab)
export const selectGlobalNotifications = createDraftSafeSelector(state, (store) => store.notifications??[] as GlobalNotificationProto[])
export const selectNewGlobalNotifications = createDraftSafeSelector(state, (store) => store?.newNotifcations??[] as GlobalNotificationProto[])